export enum VolumeAndWeightUnits {
  CubicYards = 'cy',
  Tons = 't'
}

export enum DistanceUnits {
  Miles = 'mi',
  Kilometers = 'km'
}
